window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      document.querySelectorAll('.cpap__flyout-hst-button').forEach((node) => {
        node.addEventListener('click', (event) => {
          event.preventDefault();

          window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapHstFlyout);

          const popupClassQuerySelector = '.cpap__flyout-hst';

          // Show elements
          ['.age-verification', '.age-older-22', '.terms-conditions-1'].forEach((query) =>
            document.querySelector(query).classList.remove('d-none')
          );
          // Hide elements
          ['.youngerthan-popup', '.terms-conditions', '.terms-conditions-2'].forEach((query) =>
            document.querySelector(query).classList.add('d-none')
          );

          document.getElementById('terms-conditions-checkbox').checked = false;
          document.querySelector('.agree-continue-btn-1').setAttribute('disabled', 'disabled');

          window.cpap.openFlyout(popupClassQuerySelector);
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
